import { useState, createContext, ReactNode } from 'react';
import { Web3DepositModal } from '@web3fe/infra';

type DepositInfo = {
  chainCode: string;
  token: string;
  walletAddress?: string;
};

export const DepositContext = createContext<{
  openDeposit: (info: DepositInfo) => void;
}>({
  openDeposit: () => undefined,
});

DepositContext.displayName = 'DepositContext';
interface Props {
  children: ReactNode;
}

export const DepositProvider = (props: Props) => {
  const { children } = props;

  const [showDeposit, setShowDeposit] = useState(false);
  const [info, setInfo] = useState<DepositInfo>();

  const openDeposit = (info: DepositInfo) => {
    setInfo(info);
    setShowDeposit(true);
  };

  return (
    <DepositContext.Provider
      value={{
        openDeposit,
      }}
    >
      <Web3DepositModal
        visible={showDeposit}
        token={{
          chainCode: info?.chainCode,
          token: info?.token,
          walletAddress: info?.walletAddress,
        }}
        onClose={() => {
          setShowDeposit(false);
        }}
      />
      {children}
    </DepositContext.Provider>
  );
};
